import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { ApiConfigService } from './api-config.service'
import { StoreSession } from 'src/app/store/store-session'
import { CognitoService } from './cognito.service'
import { AuthService } from '@session/services/auth.service'
import { NavController } from '@ionic/angular'
import { PushNotificationsService } from './push-notifications.service'

@Injectable({
  providedIn: 'root',
})
export class SessionActionsService {
  http = inject(HttpClient)
  apiConfig = inject(ApiConfigService)
  store = inject(StoreSession)
  cognitoService = inject(CognitoService)
  authService = inject(AuthService)
  navController = inject(NavController)
  pushNotificationsService = inject(PushNotificationsService)

  /**
   * Refresh the session token
   * @returns boolean if the session was refreshed
   */
  async refreshSession(): Promise<boolean> {
    const token: string | undefined = await this.cognitoService.currentSession()
    if (token) {
      this.store.changeAccesToken(token!)
      this.http.patch(`${this.apiConfig.API_AUTH}/refresh`, {}).subscribe(resp => {
        const res = resp as { token: string }
        this.store.changeAccesToken(res.token)
      })
      return true
    } else {
      this.logOut()
      return false
    }
  }

  async logOut(logoutBackend = true, redirect = true) {
    // this.pushNotificationsService.unregisterDevice()
    if (logoutBackend) {
      // this.pushNotificationsService.removeDeviceToken(this.store.session.deviceToken()).subscribe()
      this.authService.logOut().subscribe()
    }
    this.cognitoService.handleSignOut()
    this.store.logOut()

    if (redirect) {
      this.navController.navigateBack('session/login', { animated: true, replaceUrl: true })
    }
  }
}
